import * as React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useAreaPreference } from "../../../hooks/useAreaPreference";
import PayrollReview from "../../sessions/sessionDetail/payroll/Reports/payrollReview";
import RealReview from "../../sessions/sessionDetail/payroll/Reports/realReview";
import ReconcileReview from "../../sessions/sessionDetail/payroll/Reports/reconcileReview";
import OfcUsageReview from "../../sessions/sessionDetail/payroll/Reports/ofcUsageReview";
import WhenWasIPaidReview from "../../sessions/sessionDetail/payroll/Reports/whenWasIPaidReview";

interface GeneralTabProps {}

const GeneralTab: React.FC<GeneralTabProps> = () => {
    const [activeTab, setActiveTab] = useAreaPreference<number>("payroll", "general.subTab", 0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number | null) => {
        if (newValue != null) {
            setActiveTab(newValue);
        }
    };

    const tablist: [string, React.ReactNode][] = [
        [
            "Payroll Review",
            <PayrollReview sessionId={""} />,
        ],
        [
            "Real Review",
            <RealReview sessionId={""} />,
        ],
        [
            "Reconcile Review",
            <ReconcileReview sessionId={""} />,
        ],
        [
            "OFC Usage Review",
            <OfcUsageReview sessionId={""} />,
        ],
        [
            "When Was I Paid Review",
            <WhenWasIPaidReview sessionId={""} />,
        ],
    ];

    const safeActiveTab = activeTab >= 0 && activeTab < tablist.length ? activeTab : 0;

    return (
        <Box sx={{ width: 1, height: 1, display: "flex", flexDirection: "column" }}>
            <Box sx={{ borderWidth: 0, flexGrow: 0 }}>
                <ToggleButtonGroup
                    color="primary"
                    value={safeActiveTab}
                    exclusive
                    onChange={handleTabChange}
                    sx={{ mb: 2, display: "flex", flexWrap: "wrap", justifyContent: "center" }}
                >
                    {tablist.map((tab, i) => (
                        <ToggleButton
                            key={i}
                            id={`payroll-general-tab-${i}`}
                            value={i}
                        >
                            {tab[0]}
                        </ToggleButton>
                    ))}
                </ToggleButtonGroup>
            </Box>
            <Box sx={{ width: 1, flexGrow: 1 }}>
                {tablist[safeActiveTab][1]}
            </Box>
        </Box>
    );
};

export default GeneralTab;
